<script lang="ts">
	// Permanent deletion confirm (Trash, SAY-1463 / bulk SAY-1820). Irreversible:
	// drops the chat(s), their history and worktrees, so every permanent delete
	// is gated behind this — Open WebUI's ConfirmDialog shape (rounded-3xl, two
	// full-width h-7 buttons).
	import * as Dialog from '$lib/components/ui/dialog/index.js';
	import Spinner from './Spinner.svelte';
	import type { Snippet } from 'svelte';

	let {
		open = $bindable(false),
		title,
		busy = false,
		confirmLabel = 'Confirm',
		onConfirm,
		children,
	}: {
		open?: boolean;
		title: string;
		busy?: boolean;
		confirmLabel?: string;
		onConfirm: () => void;
		children: Snippet;
	} = $props();
</script>

<Dialog.Root
	bind:open
	onOpenChange={(v) => {
		if (!v && busy) open = true; // a delete in flight can't be dismissed
	}}
>
	<Dialog.Content
		class="w-[32rem] max-w-[calc(100%-1rem)] gap-0 rounded-3xl border border-white bg-white px-5 py-5 dark:border-gray-900 dark:bg-gray-950"
		showCloseButton={false}
	>
		<Dialog.Header class="gap-0 text-left">
			<Dialog.Title class="mb-2.5 text-sm font-medium text-gray-900 dark:text-gray-200">{title}</Dialog.Title>
			<Dialog.Description class="text-sm text-gray-500">
				{@render children()}
			</Dialog.Description>
		</Dialog.Header>
		<div class="mt-5 flex justify-between gap-1.5">
			<button
				type="button"
				class="flex h-7 w-full items-center justify-center gap-1.5 rounded-lg bg-gray-100 px-2.5 text-xs font-normal text-gray-800 transition hover:bg-gray-100/70 disabled:opacity-60 dark:bg-gray-850 dark:text-white dark:hover:bg-gray-850/60"
				onclick={() => (open = false)}
				disabled={busy}
			>
				Cancel
			</button>
			<button
				type="button"
				class="flex h-7 w-full items-center justify-center gap-1.5 rounded-lg bg-gray-900 px-2.5 text-xs font-normal text-white transition hover:bg-black disabled:opacity-60 dark:bg-gray-100 dark:text-gray-900 dark:hover:bg-white"
				onclick={onConfirm}
				disabled={busy}
				data-testid="confirm-delete"
			>
				{#if busy}
					<Spinner class="size-3" />
				{/if}
				{confirmLabel}
			</button>
		</div>
	</Dialog.Content>
</Dialog.Root>
